import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import ClientOnly from 'app/components/ClientOnly'
import { getCustomBlock } from 'app/components/CustomBlocks'
import { TReusableBlock } from 'app/service/api/theme'
import { useGlobalState } from 'app/store'

const Block = require('react-gutenberg').WPGBlock

interface IProps {
  blocks: IWPGBlock[]
  mapToBlock?: (name: string) => any | null
}

const Blocks: React.FC<IProps> = (props) => (
  <>
    {props.blocks
      .filter((block) => !!block.blockName)
      .map((block, index) => (
        <Block key={`${block.blockName}-${index}`} block={block} mapToBlock={props.mapToBlock ?? getCustomBlock} />
      ))}
  </>
)

export const renderBlocks = (
  props: IProps,
  reusableBlocks?: TReusableBlock,
  mapToBlock?: (name: string) => any | null,
) => {
  return props.blocks
    .filter((block) => !!block.blockName)
    .map((block, index) => {
      if (block.blockName === 'core/block' && reusableBlocks) {
        for (const [key, value] of reusableBlocks.entries()) {
          // @ts-ignore
          if (value.id === block.attrs.ref) {
            return (
              <Block
                key={`${block.blockName}-${index}`}
                block={
                  {
                    blockName: value.name,
                    attrs: value.attrs,
                    innerBlocks: value?.innerBlocks || [],
                    innerContent: [],
                    innerHTML: '',
                  } as IWPGBlock
                }
                mapToBlock={mapToBlock}
              />
            )
          }
        }
      }

      return <Block key={`${block.blockName}-${index}`} block={block} mapToBlock={mapToBlock} />
    })
}

interface IWrapperProps {
  innerBlocks: IWPGBlock[]
  render?: (blocks: any[]) => React.ReactElement
  renderCustomBlock?: (name: string) => any | null
  withoutClientOnly?: boolean
}

export const ReactBlocks: React.FC<IWrapperProps> = (props) => {
  const [blocks] = useGlobalState('reusableBlocks')
  const mapToBlock = (name: string) => props.renderCustomBlock?.(name) ?? getCustomBlock(name)
  const renderedBlocks = renderBlocks({ blocks: props.innerBlocks, mapToBlock }, blocks, mapToBlock)

  if (props.withoutClientOnly) {
    return <>{props.render ? props.render(renderedBlocks) : <>{renderedBlocks}</>}</>
  }

  return <ClientOnly>{props.render ? props.render(renderedBlocks) : <>{renderedBlocks}</>}</ClientOnly>
}

export default Blocks
